import { AddIcon, RepeatIcon } from "@chakra-ui/icons";
import { Box, Button, Grid, Text } from "@chakra-ui/react";
import { CustomTableColor } from "components/dynamic-table/color-table";
import { AccordionEquipeRow } from "components/equipes-de-venda-components/accordion-row";
import {
  ModalEquipes,
  openModalEquipes
} from "components/equipes-de-venda-components/modal-equipe";
import {
  EquipeVendaRowProps,
  getColumnsEquipesVendasTable,
  getEquipesList,
  getUsersEquipes
} from "components/equipes-de-venda-components/utils";
import { GetLayout } from "components/get-layout";
import { InputField } from "components/input-field";
import { PageTitle } from "components/title-with-back-button";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useEffect, useState } from "react";
import { filterArrayBy } from "utils/filter-array-by";
import { RoutePermissionFunction } from "router-manager/parts";

function EquipesDeVendaPage() {
  const [equipesList, setEquipesList] = useState<EquipeVendaRowProps[]>([]);
  const [activeIndex, setActiveIndex] = useState<number>();
  const [isLoading, setIsLoading] = useState(false);
  const [filterNome, setFilterNome] = useState("");
  const [users, setUsers] = useState<
    { name: string; value: number; isVendeAI: boolean }[]
  >([]);
  const { user } = useApplicationContext();
  const customer_id = user.userData.customerId!;

  const filteredEquipes = filterArrayBy(equipesList, filterNome, ["nome"], {
    partialSearch: true,
    sortBy: "nome"
  });

  const getEquipes = () =>
    getEquipesList(setIsLoading, setEquipesList, customer_id!);

  useEffect(() => {
    getEquipes();
  }, []);

  useEffect(() => {
    getUsersEquipes({ setUsers, customer_id });
  }, []);

  return (
    <GetLayout title="Equipes de Venda">
      <Grid templateColumns="3fr 1fr" w="100%" gap="10px" mb="20px">
        <Box>
          <InputField
            title="Filtrar por Nome da equipe"
            onChange={({ target: { value } }) => {
              setFilterNome(value);
              setActiveIndex(undefined);
            }}
            value={filterNome}
            inputProps={{ bg: "#fff", placeholder: "Buscar equipe..." }}
          />
        </Box>
        <Grid templateColumns="1fr 1fr" gap="8px">
          <Box>
            <Text mb="8px">&nbsp;</Text>
            <Button
              leftIcon={<AddIcon w="15px" h="15px" />}
              w="100%"
              onClick={(e) => openModalEquipes()}
            >
              Adicionar Equipe
            </Button>
          </Box>
          <Box>
            <Text mb="8px">&nbsp;</Text>
            <Button
              leftIcon={<RepeatIcon />}
              w="100%"
              onClick={() => getEquipes()}
            >
              Atualizar
            </Button>
          </Box>
        </Grid>
      </Grid>
      <CustomTableColor
        columns={getColumnsEquipesVendasTable({
          onUpdate: getEquipes,
          setActiveIndex,
          activeIndex
        })}
        rows={filteredEquipes}
        isLoading={isLoading}
        InnerRowRender={AccordionEquipeRow}
        loadingRowsCount={5}
        onClickRow={(row, i) =>
          row.usersIds?.length
            ? setActiveIndex((active) => (i === active ? undefined : i))
            : undefined
        }
        innerRowRenderProps={{ activeIndex, users }}
        onChangeIndexPage={() => setActiveIndex(undefined)}
      />
      <ModalEquipes onUpdate={() => getEquipes()} users={users} />
    </GetLayout>
  );
}

export default EquipesDeVendaPage;

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission([
    "SUPER",
    "REGIONAL",
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_MASTER"
  ]);
};
